import gql from "graphql-tag";

const ADD_WALLET_MUTATION = gql`
    mutation addWallet(
        $address: String!
        $signature: SignatureType!
        $msgConfirmation: String!
        $blockchain: String!
    ) {
        addWallet(
            addWalletInput: {
                address: $address
                signature: $signature
                msgConfirmation: $msgConfirmation
                blockchain: $blockchain
            }
        )   {
            id
            address
            verified
            userId
            currencyId
            blockchain
        }
    }
`;

export default ADD_WALLET_MUTATION;